import { Navigate } from "react-router-dom";

export default function Root() {
    return <Navigate to={"/rise/raw-data-export-type"} />
}